import { Observable } from "rxjs";
import { Component } from "@angular/core";
import { AuthService } from "@wgu-edu/wgu-core";

@Component({
  templateUrl: "./template/landingPage.component.html",
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
    `,
  ],
})
export class LandingPageComponent {
  isAuthenticated$: Observable<boolean>;

  constructor(private authService: AuthService) {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
  }
}
